import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import {
  HTTPResponseError,
  PromocodeAlreadyActivatedError,
  PromocodeNotFoundError,
} from 'utils/errors';
import { getM8UserURL } from 'services/production/utils/getM8URL';

type Params = {
  promocode: string;
};

export const applyPromocode = async (params: Params): Promise<void> => {
  const fetchURL = getM8UserURL('applyPromocode');

  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 400) {
      throw new PromocodeAlreadyActivatedError();
    }

    if (response.status === 404) {
      throw new PromocodeNotFoundError();
    }

    throw new HTTPResponseError(response);
  }
};
